import { render, staticRenderFns } from "./TitleBar.vue?vue&type=template&id=95881f5a&scoped=true&lang=pug&"
import script from "./TitleBar.vue?vue&type=script&lang=ts&"
export * from "./TitleBar.vue?vue&type=script&lang=ts&"
import style0 from "./TitleBar.vue?vue&type=style&index=0&id=95881f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95881f5a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrevBack: require('/app/src/components/atoms/PrevBack.vue').default})
